import React from "react";
import PropTypes from "prop-types";
import { Label } from "semantic-ui-react";

const TotalFineDisplay = ({ totalFine, loans = [] }) => {
  // Calculate total fine from loans if totalFine is 0 or not provided
  const displayFine =
    totalFine > 0
      ? totalFine
      : loans.reduce((total, loan) => total + (loan.calculatedFine || 0), 0);

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("en-PH", {
      style: "currency",
      currency: "PHP",
      minimumFractionDigits: 2,
    }).format(amount);
  };

  if (displayFine === 0) {
    return (
      <Label color="green" size="small">
        {formatCurrency(0)}
      </Label>
    );
  }

  return (
    <Label color={displayFine > 100 ? "red" : "orange"} size="small">
      {formatCurrency(displayFine)}
    </Label>
  );
};

TotalFineDisplay.propTypes = {
  totalFine: PropTypes.number,
  loans: PropTypes.array,
};

TotalFineDisplay.defaultProps = {
  totalFine: 0,
  loans: [],
};

export default TotalFineDisplay;
